import { render } from "./GymnastManagement.vue?vue&type=template&id=65d29491&scoped=true"
import script from "./GymnastManagement.vue?vue&type=script&lang=js"
export * from "./GymnastManagement.vue?vue&type=script&lang=js"

import "./GymnastManagement.vue?vue&type=style&index=0&id=65d29491&scoped=true&lang=css"
import "./GymnastManagement.vue?vue&type=style&index=1&id=65d29491&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d29491"]])

export default __exports__